<template>
	<div>
		<app-header
			:location-data="localAddress"
		></app-header>
		<router-view></router-view>
	</div>
</template>

<script>
	import appHeader from '@/components/market-place/app-header';

	function created() {
		this.onLocalAddress();
	}

	export default {
		name: 'page-market-place',
		components: {
			appHeader,
		},
		created,
	};
</script>


// WEBPACK FOOTER //
// src/pages/market-place/page-market-place.vue